import { render } from "./ListeTaille.vue?vue&type=template&id=c81133e6&ts=true"
import script from "./ListeTaille.vue?vue&type=script&lang=ts"
export * from "./ListeTaille.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__